import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetChannelDashboard_channelDashboard as ChannelDashboard,
    GetChannelDashboard as GetChannelDashboardQuery,
    GetChannelDashboardVariables as GetChannelDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_CHANNEL_DASHBOARD from '../queries/get-channel-dashboard.graphql';

export const useGetChannelDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    channelDashboard: ChannelDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetChannelDashboardQuery,
        GetChannelDashboardQueryVariables
    >(GET_CHANNEL_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {channelDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        channelDashboard,
    };
};
